const BASE_API_URL_REPORTES = 'https://api.powerbi.com/v1.0/myorg/reports/';

export { BASE_API_URL_REPORTES };
